import isEmpty from 'lodash-es/isEmpty';
import { createContext, useState, useContext, PropsWithChildren, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getSelectedWorkspace, getCurrentUserWorkspacePlan } from 'wisestep-api';
import { IWorkspace, IWorkspaceContext } from 'wisestep-base';

export const WorkspaceContext = createContext<IWorkspaceContext | null>(null);

export default function WorkspaceContextProvider(
  props: PropsWithChildren<IWorkspaceContext | null>
) {
  const [workspace, setWorkspace] = useState<IWorkspaceContext | null>(null);

  const navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    (async function () {
      if (isEmpty(workspace)) {
        try {
          const getWorkspace = await getSelectedWorkspace();
          const getWorkspacePlan = await getCurrentUserWorkspacePlan();
          const selectedWorkspace: IWorkspace = getWorkspace.data;
          selectedWorkspace.workspacePlan = getWorkspacePlan.data;
          setWorkspace(selectedWorkspace);
          sessionStorage.setItem('workspaceId', selectedWorkspace.id);
          // const url = window.location.origin.split('.');
          // const getSubDomain = url[0].split('/');
          // const subDomain = getSubDomain[getSubDomain.length - 1];
          // if (subDomain !== selectedWorkspace.link && location.pathname !== '/workspace/list') {
          //   navigate('/workspace/list');
          //   window.location.reload();
          // }
        } catch {
          setWorkspace(null);
        }
      }
    })();
  }, [location.pathname, navigate, workspace]);

  return (
    <WorkspaceContext.Provider value={{ ...workspace, setWorkspace }}>
      {props.children}
    </WorkspaceContext.Provider>
  );
}

export function useWorkspaceContext() {
  const context = useContext(WorkspaceContext);
  if (!context) {
    throw new Error('useAppState must be used within the WorkspaceContextProvider');
  }
  return context;
}
